module.exports = __webpack_public_path__ + "img/events.15edab2b.svg";